export default __webpack_public_path__ + "static/media/img3.d5f67b2a.svg";